import { DatePicker } from "antd"
import frLocale from "antd/es/date-picker/locale/fr_FR"
import moment, { Moment } from "moment"
import { useTranslation } from "react-i18next"
import { endOfMonth, startOfMonth, subMonths, startOfYear } from "date-fns"
import { DateRange } from "../queries"
import {
    BillingPeriodBar,
    PeriodPresetButton,
    PeriodPresets,
    PeriodTopRow
} from "../styles"

const { RangePicker } = DatePicker

const PRESET_MONTHS: Array<{ key: string, monthCount: number }> = [
    { key: '3-months', monthCount: 2 },
    { key: '6-months', monthCount: 5 },
    { key: '12-months', monthCount: 11 }
]

export default function BillingPeriodControls({
    period,
    onPeriodChange
}: {
    period: DateRange
    onPeriodChange: (value: [Moment | null, Moment | null]) => void
}) {
    const { t, i18n } = useTranslation()
    const intlLocale = i18n.language.startsWith('fr') ? 'fr-FR' : 'en-US'
    const formatMonth = (value: Moment) => {
        const month = new Intl.DateTimeFormat(intlLocale, { month: 'short' })
            .format(value.toDate()).replace('.', '').toUpperCase()
        return `${month} ${value.year()}`
    }

    const pickerValue: [Moment, Moment] = [moment(period.startDate), moment(period.endDate)]

    const applyPresetMonths = (monthCount: number) => {
        const periodEnd = endOfMonth(new Date())
        const periodStart = startOfMonth(subMonths(new Date(), monthCount))
        onPeriodChange([moment(periodStart), moment(periodEnd)])
    }

    const applyCurrentYear = () => {
        const periodStart = startOfYear(new Date())
        const periodEnd = endOfMonth(new Date())
        onPeriodChange([moment(periodStart), moment(periodEnd)])
    }

    return (
        <BillingPeriodBar>
            <PeriodTopRow>
                <RangePicker
                    className="billing-range-picker"
                    picker="month"
                    allowClear={false}
                    locale={frLocale}
                    value={pickerValue}
                    format={formatMonth}
                    onChange={(value) => value && onPeriodChange(value as [Moment | null, Moment | null])}
                />

                <PeriodPresets>
                    {PRESET_MONTHS.map((preset) => (
                        <PeriodPresetButton key={preset.key} onClick={() => applyPresetMonths(preset.monthCount)}>
                            {t(`facturation.period.${preset.key}`)}
                        </PeriodPresetButton>
                    ))}
                    <PeriodPresetButton onClick={applyCurrentYear}>
                        {t('facturation.period.current-year')}
                    </PeriodPresetButton>
                </PeriodPresets>
            </PeriodTopRow>

        </BillingPeriodBar>
    )
}
